import { jsxs as h, jsx as o } from "react/jsx-runtime";
import { CollapsibleParagraph as A } from "./index.es864.js";
import u from "classnames";
import d, { useRef as B, useState as H, useLayoutEffect as S } from "react";
import { useIsMessageTwoLine as T } from "./index.es657.js";
import e from "./index.es865.js";
import { UtilityCloseIcon as z } from "./index.es456.js";
import { ActionButton as R } from "./index.es866.js";
import { useScreenZoomSize as P } from "./index.es589.js";
import { BodyText as _ } from "./index.es505.js";
const $ = "banner-component", f = ({
  type: C = "default",
  layout: g = "top-page",
  text: N,
  LeftIcon: c,
  children: a,
  onClose: l,
  testId: m = $
}) => {
  const { containerRef: b, is2Liner: x } = T(), i = B(null), [y, E] = H(20), t = P() === "max" || g === "in-line", p = d.Children.toArray(a), v = p == null ? void 0 : p.some(
    (n) => d.isValidElement(n) && n.type === f.CollapsibleParagraph
  ), L = u(e.root, e[`${C.toLocaleLowerCase()}-type`], {
    [e["top-page-layout"]]: !t,
    [e["in-line-layout"]]: t,
    [e.noLeftIcon]: !c,
    [e.hasCloseButton]: l,
    [e.hasCtas]: !!a && !t,
    [e.fullWidthActions]: v || t
  });
  S(() => {
    const n = () => {
      if (i.current && t) {
        let s = 0;
        i.current.childNodes.forEach((r) => {
          r instanceof HTMLElement && (s += r.clientHeight);
        }), E(s);
      }
    };
    if (n(), i.current) {
      const s = new ResizeObserver(() => {
        window.requestAnimationFrame(() => {
          n();
        });
      });
      return i.current.childNodes.forEach((r) => {
        r instanceof Element && s.observe(r);
      }), () => {
        s.disconnect();
      };
    }
  }, [t, a]);
  const w = u(e.actionsContainer, {
    [e.twoLiner]: x,
    [e.hasLeftIcon]: !!c
  });
  return /* @__PURE__ */ h("div", { className: L, "data-testid": m, ref: b, children: [
    /* @__PURE__ */ h("div", { className: e.container, children: [
      c && /* @__PURE__ */ o("span", { className: e.leftIcon, children: c }),
      /* @__PURE__ */ o("div", { className: e.textContainer, children: /* @__PURE__ */ o(_, { variant: "semi-bold", element: "p", children: N }) })
    ] }),
    l && /* @__PURE__ */ o(
      "button",
      {
        className: e.closeButton,
        "data-testid": `${m}-close-button`,
        onClick: l,
        "aria-label": "close-icon",
        children: /* @__PURE__ */ o(z, {})
      }
    ),
    a && /* @__PURE__ */ o(
      "div",
      {
        ref: i,
        className: w,
        style: { maxHeight: `${y}px` },
        "data-testid": `${m}-actions-container`,
        children: a
      }
    )
  ] });
};
f.Action = R;
f.CollapsibleParagraph = A;
export {
  $ as BANNER_DEFAULT_TESTID,
  f as Banner
};
//# sourceMappingURL=index.es91.js.map
